import React, { useState } from 'react';

const ToggleButton = ({ options, value, onChange, name }) => {
  return (
    <div className="flex p-1 bg-gray-100 rounded-lg">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`flex-1 px-4 py-2 text-sm font-medium rounded-md transition-all duration-200
            ${value === option.value
              ? 'bg-white text-purple-600 shadow-sm'
              : 'text-gray-500 hover:text-gray-700'
            }`}
          onClick={() => onChange(option.value)}
          aria-label={`Select ${option.label}`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

const SajuForm = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    birthDate: '',
    birthTime: '',
    gender: '남',
    birthType: 'solar',
    questionType: 'general'
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const genderOptions = [
    { value: '남', label: '남자' },
    { value: '여', label: '여자' }
  ];

  const birthTypeOptions = [
    { value: 'solar', label: '양력' },
    { value: 'lunar', label: '음력' }
  ];

  const questionTypeOptions = [
    { value: 'general', label: '종합운세' },
    { value: 'career', label: '직업/사업' },
    { value: 'love', label: '연애/결혼' },
    { value: 'wealth', label: '재물/투자' },
    { value: 'health', label: '건강/체질' }
  ];

  return (
    <form onSubmit={handleSubmit} className="p-6 bg-white rounded-xl shadow-lg">
      <div className="space-y-8">
        <div className="space-y-2">
          <label className="block text-gray-700 font-medium">
            생년월일
            <span className="text-red-500">*</span>
          </label>
          <input
            type="date"
            value={formData.birthDate}
            onChange={(e) => setFormData(prev => ({
              ...prev,
              birthDate: e.target.value
            }))}
            required
            className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
          />
        </div>

        <div className="space-y-2">
          <label className="block text-gray-700 font-medium">
            태어난 시간
          </label>
          <select
            value={formData.birthTime}
            onChange={(e) => setFormData(prev => ({
              ...prev,
              birthTime: e.target.value
            }))}
            className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
          >
            <option value="">모름</option>
            <option value="자시">자시 (23:30-01:29)</option>
            <option value="축시">축시 (01:30-03:29)</option>
            <option value="인시">인시 (03:30-05:29)</option>
            <option value="묘시">묘시 (05:30-07:29)</option>
            <option value="진시">진시 (07:30-09:29)</option>
            <option value="사시">사시 (09:30-11:29)</option>
            <option value="오시">오시 (11:30-13:29)</option>
            <option value="미시">미시 (13:30-15:29)</option>
            <option value="신시">신시 (15:30-17:29)</option>
            <option value="유시">유시 (17:30-19:29)</option>
            <option value="술시">술시 (19:30-21:29)</option>
            <option value="해시">해시 (21:30-23:29)</option>
          </select>
        </div>

        <div className="space-y-2">
          <label className="block text-gray-700 font-medium">
            성별
            <span className="text-red-500">*</span>
          </label>
          <ToggleButton
            options={genderOptions}
            value={formData.gender}
            onChange={(value) => setFormData(prev => ({ ...prev, gender: value }))}
            name="gender"
          />
        </div>

        <div className="space-y-2">
          <label className="block text-gray-700 font-medium">
            생일 유형
            <span className="text-red-500">*</span>
          </label>
          <ToggleButton
            options={birthTypeOptions}
            value={formData.birthType}
            onChange={(value) => setFormData(prev => ({ ...prev, birthType: value }))}
            name="birthType"
          />
        </div>

        <div className="space-y-2">
          <label className="block text-gray-700 font-medium">
            보고 싶은 운세
            <span className="text-red-500">*</span>
          </label>
          <div className="grid grid-cols-2 gap-2">
            {questionTypeOptions.map((option) => (
              <button
                key={option.value}
                type="button"
                className={`p-3 text-sm font-medium rounded-lg transition-all duration-200
                  ${formData.questionType === option.value
                    ? 'bg-purple-600 text-white'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
                onClick={() => setFormData(prev => ({
                  ...prev,
                  questionType: option.value
                }))}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>

        <button
          type="submit"
          className="w-full mt-6 bg-purple-600 hover:bg-purple-700 text-white font-medium py-3 rounded-lg transition-colors duration-200"
        >
          사주 보기
        </button>
      </div>
    </form>
  );
};

export default SajuForm; 